export const CURRENCYLIST = [
  { name: "AED", value: "&#1583;.&#1573;" },
  { name: "AFN", value: "&#65;&#102;" },
  { name: "ALL", value: "&#76;&#101;&#107;" },
  { name: "AMD", value: "&#1380;" },
  { name: "ANG", value: "&#402;" },
  { name: "AOA", value: "&#75;&#122;" },
  { name: "ARS", value: "&#36;" },
  { name: "AUD", value: "&#36;" },
  { name: "AWG", value: "&#402;" },
  { name: "AZN", value: "&#8380;" },
  { name: "BAM", value: "&#75;&#77;" },
  { name: "BBD", value: "&#36;" },
  { name: "BDT", value: "&#2547;" },
  { name: "BGN", value: "&#1083;&#1074;" },
  { name: "BHD", value: ".&#1583;.&#1576;" },
  { name: "BIF", value: "&#70;&#66;&#117;" },
  { name: "BMD", value: "&#36;" },
  { name: "BND", value: "&#36;" },
  { name: "BOB", value: "&#36;&#98;" },
  { name: "BRL", value: "&#82;&#36;" },
  { name: "BSD", value: "&#36;" },
  { name: "BTN", value: "&#78;&#117;&#46;" },
  { name: "BWP", value: "&#80;" },
  { name: "BYR", value: "&#112;&#46;" },
  { name: "BZD", value: "&#66;&#90;&#36;" },
  { name: "CAD", value: "&#36;" },
  { name: "CDF", value: "&#70;&#67;" },
  { name: "CHF", value: "&#67;&#72;&#70;" },
  { name: "CLF", value: "&#85;&#70;" },
  { name: "CLP", value: "&#36;" },
  { name: "CNY", value: "&#165;" },
  { name: "COP", value: "&#36;" },
  { name: "CRC", value: "&#8353;" },
  { name: "CUP", value: "&#8396;" },
  { name: "CVE", value: "&#36;" },
  { name: "CZK", value: "&#75;&#269;" },
  { name: "DJF", value: "&#70;&#100;&#106;" },
  { name: "DKK", value: "&#107;&#114;" },
  { name: "DOP", value: "&#82;&#68;&#36;" },
  { name: "DZD", value: "&#1583;&#1580;" },
  { name: "EGP", value: "E&#163;" },
  { name: "ETB", value: "&#66;&#114;" },
  { name: "EUR", value: "&#8364;" },
  { name: "FJD", value: "&#36;" },
  { name: "FKP", value: "&#163;" },
  { name: "GBP", value: "&#163;" },
  { name: "GEL", value: "&#4314;" },
  { name: "GHS", value: "&#162;" },
  { name: "GIP", value: "&#163;" },
  { name: "GMD", value: "&#68;" },
  { name: "GNF", value: "&#70;&#71;" },
  { name: "GTQ", value: "&#81;" },
  { name: "GYD", value: "&#36;" },
  { name: "HKD", value: "&#36;" },
  { name: "HNL", value: "&#76;" },
  { name: "HRK", value: "&#107;&#110;" },
  { name: "HTG", value: "&#71;" },
  { name: "HUF", value: "&#70;&#116;" },
  { name: "IDR", value: "&#82;&#112;" },
  { name: "ILS", value: "&#8362;" },
  { name: "INR", value: "&#8377;" },
  { name: "IQD", value: "&#1593;.&#1583;" },
  { name: "IRR", value: "&#65020;" },
  { name: "ISK", value: "&#107;&#114;" },
  { name: "JEP", value: "&#163;" },
  { name: "JMD", value: "&#74;&#36;" },
  { name: "JOD", value: "&#74;&#68;" },
  { name: "JPY", value: "&#165;" },
  { name: "KES", value: "&#75;&#83;&#104;" },
  { name: "KGS", value: "&#1083;&#1074;" },
  { name: "KHR", value: "&#6107;" },
  { name: "KMF", value: "&#67;&#70;" },
  { name: "KPW", value: "&#8361;" },
  { name: "KRW", value: "&#8361;" },
  { name: "KWD", value: "&#1583;.&#1603;" },
  { name: "KYD", value: "&#36;" },
  { name: "KZT", value: "&#8376;" },
  { name: "LAK", value: "&#8365;" },
  { name: "LBP", value: "&#163;" },
  { name: "LKR", value: "&#8360;" },
  { name: "LRD", value: "&#36;" },
  { name: "LSL", value: "&#76;" },
  { name: "LTL", value: "&#76;&#116;" },
  { name: "LVL", value: "&#76;&#115;" },
  { name: "LYD", value: "&#1604;.&#1583;" },
  { name: "MAD", value: "&#1583;.&#1605;." },
  { name: "MDL", value: "&#76;" },
  { name: "MGA", value: "&#65;&#114;" },
  { name: "MKD", value: "&#1076;&#1077;&#1085;" },
  { name: "MMK", value: "&#75;" },
  { name: "MNT", value: "&#8366;" },
  { name: "MOP", value: "&#77;&#79;&#80;&#36;" },
  { name: "MRO", value: "&#85;&#77;" },
  { name: "MUR", value: "&#8360;" },
  { name: "MVR", value: ".&#1923;" },
  { name: "MWK", value: "&#77;&#75;" },
  { name: "MXN", value: "&#36;" },
  { name: "MYR", value: "&#82;&#77;" },
  { name: "MZN", value: "&#77;&#84;" },
  { name: "NAD", value: "&#36;" },
  { name: "NGN", value: "&#8358;" },
  { name: "NIO", value: "&#67;&#36;" },
  { name: "NOK", value: "&#107;&#114;" },
  { name: "NPR", value: "&#8360;" },
  { name: "NZD", value: "&#36;" },
  { name: "OMR", value: "&#65020;" },
  { name: "PAB", value: "&#66;&#47;&#46;" },
  { name: "PEN", value: "&#83;&#47;&#46;" },
  { name: "PGK", value: "&#75;" },
  { name: "PHP", value: "&#8369;" },
  { name: "PKR", value: "&#8360;" },
  { name: "PLN", value: "&#122;&#322;" },
  { name: "PYG", value: "&#71;&#115;" },
  { name: "QAR", value: "&#65020;" },
  { name: "RON", value: "&#108;&#101;&#105;" },
  { name: "RSD", value: "&#1044;&#1080;&#1085;&#46;" },
  { name: "RUB", value: "&#8381;" },
  { name: "RWF", value: "&#1585;.&#1587;" },
  { name: "SAR", value: "&#65020;" },
  { name: "SBD", value: "&#36;" },
  { name: "SCR", value: "&#8360;" },
  { name: "SDG", value: "&#163;" },
  { name: "SEK", value: "&#107;&#114;" },
  { name: "SGD", value: "&#36;" },
  { name: "SHP", value: "&#163;" },
  { name: "SLL", value: "&#76;&#101;" },
  { name: "SOS", value: "&#83;" },
  { name: "SRD", value: "&#36;" },
  { name: "STD", value: "&#68;&#98;" },
  { name: "SVC", value: "&#36;" },
  { name: "SYP", value: "&#163;" },
  { name: "SZL", value: "&#76;" },
  { name: "THB", value: "&#3647;" },
  { name: "TJS", value: "&#84;&#74;&#83;" },
  { name: "TMT", value: "&#109;" },
  { name: "TND", value: "&#1583;.&#1578;" },
  { name: "TOP", value: "&#84;&#36;" },
  { name: "TRY", value: "&#8356;" },
  { name: "TTD", value: "&#36;" },
  { name: "TWD", value: "&#78;&#84;&#36;" },
  { name: "TZS", value: "&#84;&#83;&#104;" },
  { name: "UAH", value: "&#8372;" },
  { name: "UGX", value: "&#85;&#83;&#104;" },
  { name: "USD", value: "&#36;" },
  { name: "UYU", value: "&#36;&#85;" },
  { name: "UZS", value: "&#1083;&#1074;" },
  { name: "VEF", value: "&#66;&#115;" },
  { name: "VND", value: "&#8363;" },
  { name: "VUV", value: "&#86;&#84;" },
  { name: "WST", value: "&#87;&#83;&#36;" },
  { name: "XAF", value: "&#70;&#67;&#70;&#65;" },
  { name: "XCD", value: "&#36;" },
  { name: "XDR", value: "&#83;&#68;&#82;" },
  { name: "XOF", value: "&#70;&#67;&#70;&#65;" },
  { name: "XPF", value: "&#70;" },
  { name: "YER", value: "&#65020;" },
  { name: "ZAR", value: "&#82;" },
  { name: "ZMK", value: "&#90;&#75;" },
  { name: "ZWL", value: "&#90;&#36;" },
];

export const TIMEZONESLIST = [
  { name: "Africa/Abidjan", id: "Africa/Abidjan" },
  { name: "Africa/Accra", id: "Africa/Accra" },
  { name: "Africa/Addis_Ababa", id: "Africa/Addis_Ababa" },
  { name: "Africa/Algiers", id: "Africa/Algiers" },
  { name: "Africa/Asmara", id: "Africa/Asmara" },
  { name: "Africa/Asmera", id: "Africa/Asmera" },
  { name: "Africa/Bamako", id: "Africa/Bamako" },
  { name: "Africa/Bangui", id: "Africa/Bangui" },
  { name: "Africa/Banjul", id: "Africa/Banjul" },
  { name: "Africa/Bissau", id: "Africa/Bissau" },
  { name: "Africa/Blantyre", id: "Africa/Blantyre" },
  { name: "Africa/Brazzaville", id: "Africa/Brazzaville" },
  { name: "Africa/Bujumbura", id: "Africa/Bujumbura" },
  { name: "Africa/Cairo", id: "Africa/Cairo" },
  { name: "Africa/Casablanca", id: "Africa/Casablanca" },
  { name: "Africa/Ceuta", id: "Africa/Ceuta" },
  { name: "Africa/Conakry", id: "Africa/Conakry" },
  { name: "Africa/Dakar", id: "Africa/Dakar" },
  { name: "Africa/Dar_es_Salaam", id: "Africa/Dar_es_Salaam" },
  { name: "Africa/Djibouti", id: "Africa/Djibouti" },
  { name: "Africa/Douala", id: "Africa/Douala" },
  { name: "Africa/El_Aaiun", id: "Africa/El_Aaiun" },
  { name: "Africa/Freetown", id: "Africa/Freetown" },
  { name: "Africa/Gaborone", id: "Africa/Gaborone" },
  { name: "Africa/Harare", id: "Africa/Harare" },
  { name: "Africa/Johannesburg", id: "Africa/Johannesburg" },
  { name: "Africa/Juba", id: "Africa/Juba" },
  { name: "Africa/Kampala", id: "Africa/Kampala" },
  { name: "Africa/Khartoum", id: "Africa/Khartoum" },
  { name: "Africa/Kigali", id: "Africa/Kigali" },
  { name: "Africa/Kinshasa", id: "Africa/Kinshasa" },
  { name: "Africa/Lagos", id: "Africa/Lagos" },
  { name: "Africa/Libreville", id: "Africa/Libreville" },
  { name: "Africa/Lome", id: "Africa/Lome" },
  { name: "Africa/Luanda", id: "Africa/Luanda" },
  { name: "Africa/Lubumbashi", id: "Africa/Lubumbashi" },
  { name: "Africa/Lusaka", id: "Africa/Lusaka" },
  { name: "Africa/Malabo", id: "Africa/Malabo" },
  { name: "Africa/Maputo", id: "Africa/Maputo" },
  { name: "Africa/Maseru", id: "Africa/Maseru" },
  { name: "Africa/Mbabane", id: "Africa/Mbabane" },
  { name: "Africa/Mogadishu", id: "Africa/Mogadishu" },
  { name: "Africa/Monrovia", id: "Africa/Monrovia" },
  { name: "Africa/Nairobi", id: "Africa/Nairobi" },
  { name: "Africa/Ndjamena", id: "Africa/Ndjamena" },
  { name: "Africa/Niamey", id: "Africa/Niamey" },
  { name: "Africa/Nouakchott", id: "Africa/Nouakchott" },
  { name: "Africa/Ouagadougou", id: "Africa/Ouagadougou" },
  { name: "Africa/Porto-Novo", id: "Africa/Porto-Novo" },
  { name: "Africa/Sao_Tome", id: "Africa/Sao_Tome" },
  { name: "Africa/Timbuktu", id: "Africa/Timbuktu" },
  { name: "Africa/Tripoli", id: "Africa/Tripoli" },
  { name: "Africa/Tunis", id: "Africa/Tunis" },
  { name: "Africa/Windhoek", id: "Africa/Windhoek" },
  { name: "America/Adak", id: "America/Adak" },
  { name: "America/Anchorage", id: "America/Anchorage" },
  { name: "America/Anguilla", id: "America/Anguilla" },
  { name: "America/Antigua", id: "America/Antigua" },
  { name: "America/Araguaina", id: "America/Araguaina" },
  {
    name: "America/Argentina/Buenos_Aires",
    id: "America/Argentina/Buenos_Aires",
  },
  { name: "America/Argentina/Catamarca", id: "America/Argentina/Catamarca" },
  {
    name: "America/Argentina/ComodRivadavia",
    id: "America/Argentina/ComodRivadavia",
  },
  { name: "America/Argentina/Cordoba", id: "America/Argentina/Cordoba" },
  { name: "America/Argentina/Jujuy", id: "America/Argentina/Jujuy" },
  { name: "America/Argentina/La_Rioja", id: "America/Argentina/La_Rioja" },
  { name: "America/Argentina/Mendoza", id: "America/Argentina/Mendoza" },
  {
    name: "America/Argentina/Rio_Gallegos",
    id: "America/Argentina/Rio_Gallegos",
  },
  { name: "America/Argentina/Salta", id: "America/Argentina/Salta" },
  { name: "America/Argentina/San_Juan", id: "America/Argentina/San_Juan" },
  { name: "America/Argentina/San_Luis", id: "America/Argentina/San_Luis" },
  { name: "America/Argentina/Tucuman", id: "America/Argentina/Tucuman" },
  { name: "America/Argentina/Ushuaia", id: "America/Argentina/Ushuaia" },
  { name: "America/Aruba", id: "America/Aruba" },
  { name: "America/Asuncion", id: "America/Asuncion" },
  { name: "America/Atikokan", id: "America/Atikokan" },
  { name: "America/Atka", id: "America/Atka" },
  { name: "America/Bahia", id: "America/Bahia" },
  { name: "America/Bahia_Banderas", id: "America/Bahia_Banderas" },
  { name: "America/Barbados", id: "America/Barbados" },
  { name: "America/Belem", id: "America/Belem" },
  { name: "America/Belize", id: "America/Belize" },
  { name: "America/Blanc-Sablon", id: "America/Blanc-Sablon" },
  { name: "America/Boa_Vista", id: "America/Boa_Vista" },
  { name: "America/Bogota", id: "America/Bogota" },
  { name: "America/Boise", id: "America/Boise" },
  { name: "America/Buenos_Aires", id: "America/Buenos_Aires" },
  { name: "America/Cambridge_Bay", id: "America/Cambridge_Bay" },
  { name: "America/Campo_Grande", id: "America/Campo_Grande" },
  { name: "America/Cancun", id: "America/Cancun" },
  { name: "America/Caracas", id: "America/Caracas" },
  { name: "America/Catamarca", id: "America/Catamarca" },
  { name: "America/Cayenne", id: "America/Cayenne" },
  { name: "America/Cayman", id: "America/Cayman" },
  { name: "America/Chicago", id: "America/Chicago" },
  { name: "America/Chihuahua", id: "America/Chihuahua" },
  { name: "America/Coral_Harbour", id: "America/Coral_Harbour" },
  { name: "America/Cordoba", id: "America/Cordoba" },
  { name: "America/Costa_Rica", id: "America/Costa_Rica" },
  { name: "America/Creston", id: "America/Creston" },
  { name: "America/Cuiaba", id: "America/Cuiaba" },
  { name: "America/Curacao", id: "America/Curacao" },
  { name: "America/Danmarkshavn", id: "America/Danmarkshavn" },
  { name: "America/Dawson", id: "America/Dawson" },
  { name: "America/Dawson_Creek", id: "America/Dawson_Creek" },
  { name: "America/Denver", id: "America/Denver" },
  { name: "America/Detroit", id: "America/Detroit" },
  { name: "America/Dominica", id: "America/Dominica" },
  { name: "America/Edmonton", id: "America/Edmonton" },
  { name: "America/Eirunepe", id: "America/Eirunepe" },
  { name: "America/El_Salvador", id: "America/El_Salvador" },
  { name: "America/Ensenada", id: "America/Ensenada" },
  { name: "America/Fort_Wayne", id: "America/Fort_Wayne" },
  { name: "America/Fortaleza", id: "America/Fortaleza" },
  { name: "America/Glace_Bay", id: "America/Glace_Bay" },
  { name: "America/Godthab", id: "America/Godthab" },
  { name: "America/Goose_Bay", id: "America/Goose_Bay" },
  { name: "America/Grand_Turk", id: "America/Grand_Turk" },
  { name: "America/Grenada", id: "America/Grenada" },
  { name: "America/Guadeloupe", id: "America/Guadeloupe" },
  { name: "America/Guatemala", id: "America/Guatemala" },
  { name: "America/Guayaquil", id: "America/Guayaquil" },
  { name: "America/Guyana", id: "America/Guyana" },
  { name: "America/Halifax", id: "America/Halifax" },
  { name: "America/Havana", id: "America/Havana" },
  { name: "America/Hermosillo", id: "America/Hermosillo" },
  { name: "America/Indiana/Indianapolis", id: "America/Indiana/Indianapolis" },
  { name: "America/Indiana/Knox", id: "America/Indiana/Knox" },
  { name: "America/Indiana/Marengo", id: "America/Indiana/Marengo" },
  { name: "America/Indiana/Petersburg", id: "America/Indiana/Petersburg" },
  { name: "America/Indiana/Tell_City", id: "America/Indiana/Tell_City" },
  { name: "America/Indiana/Vevay", id: "America/Indiana/Vevay" },
  { name: "America/Indiana/Vincennes", id: "America/Indiana/Vincennes" },
  { name: "America/Indiana/Winamac", id: "America/Indiana/Winamac" },
  { name: "America/Indianapolis", id: "America/Indianapolis" },
  { name: "America/Inuvik", id: "America/Inuvik" },
  { name: "America/Iqaluit", id: "America/Iqaluit" },
  { name: "America/Jamaica", id: "America/Jamaica" },
  { name: "America/Jujuy", id: "America/Jujuy" },
  { name: "America/Juneau", id: "America/Juneau" },
  { name: "America/Kentucky/Louisville", id: "America/Kentucky/Louisville" },
  { name: "America/Kentucky/Monticello", id: "America/Kentucky/Monticello" },
  { name: "America/Knox_IN", id: "America/Knox_IN" },
  { name: "America/Kralendijk", id: "America/Kralendijk" },
  { name: "America/La_Paz", id: "America/La_Paz" },
  { name: "America/Lima", id: "America/Lima" },
  { name: "America/Los_Angeles", id: "America/Los_Angeles" },
  { name: "America/Louisville", id: "America/Louisville" },
  { name: "America/Lower_Princes", id: "America/Lower_Princes" },
  { name: "America/Maceio", id: "America/Maceio" },
  { name: "America/Managua", id: "America/Managua" },
  { name: "America/Manaus", id: "America/Manaus" },
  { name: "America/Marigot", id: "America/Marigot" },
  { name: "America/Martinique", id: "America/Martinique" },
  { name: "America/Matamoros", id: "America/Matamoros" },
  { name: "America/Mazatlan", id: "America/Mazatlan" },
  { name: "America/Mendoza", id: "America/Mendoza" },
  { name: "America/Menominee", id: "America/Menominee" },
  { name: "America/Merida", id: "America/Merida" },
  { name: "America/Metlakatla", id: "America/Metlakatla" },
  { name: "America/Mexico_City", id: "America/Mexico_City" },
  { name: "America/Miquelon", id: "America/Miquelon" },
  { name: "America/Moncton", id: "America/Moncton" },
  { name: "America/Monterrey", id: "America/Monterrey" },
  { name: "America/Montevideo", id: "America/Montevideo" },
  { name: "America/Montreal", id: "America/Montreal" },
  { name: "America/Montserrat", id: "America/Montserrat" },
  { name: "America/Nassau", id: "America/Nassau" },
  { name: "America/New_York", id: "America/New_York" },
  { name: "America/Nipigon", id: "America/Nipigon" },
  { name: "America/Nome", id: "America/Nome" },
  { name: "America/Noronha", id: "America/Noronha" },
  { name: "America/North_Dakota/Beulah", id: "America/North_Dakota/Beulah" },
  { name: "America/North_Dakota/Center", id: "America/North_Dakota/Center" },
  {
    name: "America/North_Dakota/New_Salem",
    id: "America/North_Dakota/New_Salem",
  },
  { name: "America/Ojinaga", id: "America/Ojinaga" },
  { name: "America/Panama", id: "America/Panama" },
  { name: "America/Pangnirtung", id: "America/Pangnirtung" },
  { name: "America/Paramaribo", id: "America/Paramaribo" },
  { name: "America/Phoenix", id: "America/Phoenix" },
  { name: "America/Port_of_Spain", id: "America/Port_of_Spain" },
  { name: "America/Port-au-Prince", id: "America/Port-au-Prince" },
  { name: "America/Porto_Acre", id: "America/Porto_Acre" },
  { name: "America/Porto_Velho", id: "America/Porto_Velho" },
  { name: "America/Puerto_Rico", id: "America/Puerto_Rico" },
  { name: "America/Rainy_River", id: "America/Rainy_River" },
  { name: "America/Rankin_Inlet", id: "America/Rankin_Inlet" },
  { name: "America/Recife", id: "America/Recife" },
  { name: "America/Regina", id: "America/Regina" },
  { name: "America/Resolute", id: "America/Resolute" },
  { name: "America/Rio_Branco", id: "America/Rio_Branco" },
  { name: "America/Rosario", id: "America/Rosario" },
  { name: "America/Santa_Isabel", id: "America/Santa_Isabel" },
  { name: "America/Santarem", id: "America/Santarem" },
  { name: "America/Santiago", id: "America/Santiago" },
  { name: "America/Santo_Domingo", id: "America/Santo_Domingo" },
  { name: "America/Sao_Paulo", id: "America/Sao_Paulo" },
  { name: "America/Scoresbysund", id: "America/Scoresbysund" },
  { name: "America/Shiprock", id: "America/Shiprock" },
  { name: "America/Sitka", id: "America/Sitka" },
  { name: "America/St_Barthelemy", id: "America/St_Barthelemy" },
  { name: "America/St_Johns", id: "America/St_Johns" },
  { name: "America/St_Kitts", id: "America/St_Kitts" },
  { name: "America/St_Lucia", id: "America/St_Lucia" },
  { name: "America/St_Thomas", id: "America/St_Thomas" },
  { name: "America/St_Vincent", id: "America/St_Vincent" },
  { name: "America/Swift_Current", id: "America/Swift_Current" },
  { name: "America/Tegucigalpa", id: "America/Tegucigalpa" },
  { name: "America/Thule", id: "America/Thule" },
  { name: "America/Thunder_Bay", id: "America/Thunder_Bay" },
  { name: "America/Tijuana", id: "America/Tijuana" },
  { name: "America/Toronto", id: "America/Toronto" },
  { name: "America/Tortola", id: "America/Tortola" },
  { name: "America/Vancouver", id: "America/Vancouver" },
  { name: "America/Virgin", id: "America/Virgin" },
  { name: "America/Whitehorse", id: "America/Whitehorse" },
  { name: "America/Winnipeg", id: "America/Winnipeg" },
  { name: "America/Yakutat", id: "America/Yakutat" },
  { name: "America/Yellowknife", id: "America/Yellowknife" },
  { name: "Antarctica/Casey", id: "Antarctica/Casey" },
  { name: "Antarctica/Davis", id: "Antarctica/Davis" },
  { name: "Antarctica/DumontDUrville", id: "Antarctica/DumontDUrville" },
  { name: "Antarctica/Macquarie", id: "Antarctica/Macquarie" },
  { name: "Antarctica/Mawson", id: "Antarctica/Mawson" },
  { name: "Antarctica/McMurdo", id: "Antarctica/McMurdo" },
  { name: "Antarctica/Palmer", id: "Antarctica/Palmer" },
  { name: "Antarctica/Rothera", id: "Antarctica/Rothera" },
  { name: "Antarctica/South_Pole", id: "Antarctica/South_Pole" },
  { name: "Antarctica/Syowa", id: "Antarctica/Syowa" },
  { name: "Antarctica/Vostok", id: "Antarctica/Vostok" },
  { name: "Arctic/Longyearbyen", id: "Arctic/Longyearbyen" },
  { name: "Asia/Aden", id: "Asia/Aden" },
  { name: "Asia/Almaty", id: "Asia/Almaty" },
  { name: "Asia/Amman", id: "Asia/Amman" },
  { name: "Asia/Anadyr", id: "Asia/Anadyr" },
  { name: "Asia/Aqtau", id: "Asia/Aqtau" },
  { name: "Asia/Aqtobe", id: "Asia/Aqtobe" },
  { name: "Asia/Ashgabat", id: "Asia/Ashgabat" },
  { name: "Asia/Ashkhabad", id: "Asia/Ashkhabad" },
  { name: "Asia/Baghdad", id: "Asia/Baghdad" },
  { name: "Asia/Bahrain", id: "Asia/Bahrain" },
  { name: "Asia/Baku", id: "Asia/Baku" },
  { name: "Asia/Bangkok", id: "Asia/Bangkok" },
  { name: "Asia/Beirut", id: "Asia/Beirut" },
  { name: "Asia/Bishkek", id: "Asia/Bishkek" },
  { name: "Asia/Brunei", id: "Asia/Brunei" },
  { name: "Asia/Calcutta", id: "Asia/Calcutta" },
  { name: "Asia/Choibalsan", id: "Asia/Choibalsan" },
  { name: "Asia/Chongqing", id: "Asia/Chongqing" },
  { name: "Asia/Chungking", id: "Asia/Chungking" },
  { name: "Asia/Colombo", id: "Asia/Colombo" },
  { name: "Asia/Dacca", id: "Asia/Dacca" },
  { name: "Asia/Damascus", id: "Asia/Damascus" },
  { name: "Asia/Dhaka", id: "Asia/Dhaka" },
  { name: "Asia/Dili", id: "Asia/Dili" },
  { name: "Asia/Dubai", id: "Asia/Dubai" },
  { name: "Asia/Dushanbe", id: "Asia/Dushanbe" },
  { name: "Asia/Gaza", id: "Asia/Gaza" },
  { name: "Asia/Harbin", id: "Asia/Harbin" },
  { name: "Asia/Hebron", id: "Asia/Hebron" },
  { name: "Asia/Ho_Chi_Minh", id: "Asia/Ho_Chi_Minh" },
  { name: "Asia/Hong_Kong", id: "Asia/Hong_Kong" },
  { name: "Asia/Hovd", id: "Asia/Hovd" },
  { name: "Asia/Irkutsk", id: "Asia/Irkutsk" },
  { name: "Asia/Istanbul", id: "Asia/Istanbul" },
  { name: "Asia/Jakarta", id: "Asia/Jakarta" },
  { name: "Asia/Jayapura", id: "Asia/Jayapura" },
  { name: "Asia/Jerusalem", id: "Asia/Jerusalem" },
  { name: "Asia/Kabul", id: "Asia/Kabul" },
  { name: "Asia/Kamchatka", id: "Asia/Kamchatka" },
  { name: "Asia/Karachi", id: "Asia/Karachi" },
  { name: "Asia/Kashgar", id: "Asia/Kashgar" },
  { name: "Asia/Kathmandu", id: "Asia/Kathmandu" },
  { name: "Asia/Katmandu", id: "Asia/Katmandu" },
  { name: "Asia/Khandyga", id: "Asia/Khandyga" },
  { name: "Asia/Kolkata", id: "Asia/Kolkata" },
  { name: "Asia/Krasnoyarsk", id: "Asia/Krasnoyarsk" },
  { name: "Asia/Kuala_Lumpur", id: "Asia/Kuala_Lumpur" },
  { name: "Asia/Kuching", id: "Asia/Kuching" },
  { name: "Asia/Kuwait", id: "Asia/Kuwait" },
  { name: "Asia/Macao", id: "Asia/Macao" },
  { name: "Asia/Macau", id: "Asia/Macau" },
  { name: "Asia/Magadan", id: "Asia/Magadan" },
  { name: "Asia/Makassar", id: "Asia/Makassar" },
  { name: "Asia/Manila", id: "Asia/Manila" },
  { name: "Asia/Muscat", id: "Asia/Muscat" },
  { name: "Asia/Nicosia", id: "Asia/Nicosia" },
  { name: "Asia/Novokuznetsk", id: "Asia/Novokuznetsk" },
  { name: "Asia/Novosibirsk", id: "Asia/Novosibirsk" },
  { name: "Asia/Omsk", id: "Asia/Omsk" },
  { name: "Asia/Oral", id: "Asia/Oral" },
  { name: "Asia/Phnom_Penh", id: "Asia/Phnom_Penh" },
  { name: "Asia/Pontianak", id: "Asia/Pontianak" },
  { name: "Asia/Pyongyang", id: "Asia/Pyongyang" },
  { name: "Asia/Qatar", id: "Asia/Qatar" },
  { name: "Asia/Qyzylorda", id: "Asia/Qyzylorda" },
  { name: "Asia/Rangoon", id: "Asia/Rangoon" },
  { name: "Asia/Riyadh", id: "Asia/Riyadh" },
  { name: "Asia/Saigon", id: "Asia/Saigon" },
  { name: "Asia/Sakhalin", id: "Asia/Sakhalin" },
  { name: "Asia/Samarkand", id: "Asia/Samarkand" },
  { name: "Asia/Seoul", id: "Asia/Seoul" },
  { name: "Asia/Shanghai", id: "Asia/Shanghai" },
  { name: "Asia/Singapore", id: "Asia/Singapore" },
  { name: "Asia/Taipei", id: "Asia/Taipei" },
  { name: "Asia/Tashkent", id: "Asia/Tashkent" },
  { name: "Asia/Tbilisi", id: "Asia/Tbilisi" },
  { name: "Asia/Tehran", id: "Asia/Tehran" },
  { name: "Asia/Tel_Aviv", id: "Asia/Tel_Aviv" },
  { name: "Asia/Thimbu", id: "Asia/Thimbu" },
  { name: "Asia/Thimphu", id: "Asia/Thimphu" },
  { name: "Asia/Tokyo", id: "Asia/Tokyo" },
  { name: "Asia/Ujung_Pandang", id: "Asia/Ujung_Pandang" },
  { name: "Asia/Ulaanbaatar", id: "Asia/Ulaanbaatar" },
  { name: "Asia/Ulan_Bator", id: "Asia/Ulan_Bator" },
  { name: "Asia/Urumqi", id: "Asia/Urumqi" },
  { name: "Asia/Ust-Nera", id: "Asia/Ust-Nera" },
  { name: "Asia/Vientiane", id: "Asia/Vientiane" },
  { name: "Asia/Vladivostok", id: "Asia/Vladivostok" },
  { name: "Asia/Yakutsk", id: "Asia/Yakutsk" },
  { name: "Asia/Yekaterinburg", id: "Asia/Yekaterinburg" },
  { name: "Asia/Yerevan", id: "Asia/Yerevan" },
  { name: "Atlantic/Azores", id: "Atlantic/Azores" },
  { name: "Atlantic/Bermuda", id: "Atlantic/Bermuda" },
  { name: "Atlantic/Canary", id: "Atlantic/Canary" },
  { name: "Atlantic/Cape_Verde", id: "Atlantic/Cape_Verde" },
  { name: "Atlantic/Faeroe", id: "Atlantic/Faeroe" },
  { name: "Atlantic/Faroe", id: "Atlantic/Faroe" },
  { name: "Atlantic/Jan_Mayen", id: "Atlantic/Jan_Mayen" },
  { name: "Atlantic/Madeira", id: "Atlantic/Madeira" },
  { name: "Atlantic/Reykjavik", id: "Atlantic/Reykjavik" },
  { name: "Atlantic/South_Georgia", id: "Atlantic/South_Georgia" },
  { name: "Atlantic/St_Helena", id: "Atlantic/St_Helena" },
  { name: "Atlantic/Stanley", id: "Atlantic/Stanley" },
  { name: "Australia/ACT", id: "Australia/ACT" },
  { name: "Australia/Adelaide", id: "Australia/Adelaide" },
  { name: "Australia/Brisbane", id: "Australia/Brisbane" },
  { name: "Australia/Broken_Hill", id: "Australia/Broken_Hill" },
  { name: "Australia/Canberra", id: "Australia/Canberra" },
  { name: "Australia/Currie", id: "Australia/Currie" },
  { name: "Australia/Darwin", id: "Australia/Darwin" },
  { name: "Australia/Eucla", id: "Australia/Eucla" },
  { name: "Australia/Hobart", id: "Australia/Hobart" },
  { name: "Australia/LHI", id: "Australia/LHI" },
  { name: "Australia/Lindeman", id: "Australia/Lindeman" },
  { name: "Australia/Lord_Howe", id: "Australia/Lord_Howe" },
  { name: "Australia/Melbourne", id: "Australia/Melbourne" },
  { name: "Australia/North", id: "Australia/North" },
  { name: "Australia/NSW", id: "Australia/NSW" },
  { name: "Australia/Perth", id: "Australia/Perth" },
  { name: "Australia/Queensland", id: "Australia/Queensland" },
  { name: "Australia/South", id: "Australia/South" },
  { name: "Australia/Sydney", id: "Australia/Sydney" },
  { name: "Australia/Tasmania", id: "Australia/Tasmania" },
  { name: "Australia/Victoria", id: "Australia/Victoria" },
  { name: "Australia/West", id: "Australia/West" },
  { name: "Australia/Yancowinna", id: "Australia/Yancowinna" },
  { name: "Brazil/Acre", id: "Brazil/Acre" },
  { name: "Brazil/DeNoronha", id: "Brazil/DeNoronha" },
  { name: "Brazil/East", id: "Brazil/East" },
  { name: "Brazil/West", id: "Brazil/West" },
  { name: "Canada/Atlantic", id: "Canada/Atlantic" },
  { name: "Canada/Central", id: "Canada/Central" },
  { name: "Canada/Eastern", id: "Canada/Eastern" },
  { name: "Canada/Mountain", id: "Canada/Mountain" },
  { name: "Canada/Newfoundland", id: "Canada/Newfoundland" },
  { name: "Canada/Pacific", id: "Canada/Pacific" },
  { name: "Canada/Saskatchewan", id: "Canada/Saskatchewan" },
  { name: "Canada/Yukon", id: "Canada/Yukon" },
  { name: "CET", id: "CET" },
  { name: "Chile/Continental", id: "Chile/Continental" },
  { name: "Chile/EasterIsland", id: "Chile/EasterIsland" },
  { name: "CST6CDT", id: "CST6CDT" },
  { name: "Cuba", id: "Cuba" },
  { name: "EET", id: "EET" },
  { name: "Egypt", id: "Egypt" },
  { name: "Eire", id: "Eire" },
  { name: "EST5EDT", id: "EST5EDT" },
  { name: "Etc/GMT", id: "Etc/GMT" },
  { name: "Etc/GMT+1", id: "Etc/GMT+1" },
  { name: "Etc/GMT+10", id: "Etc/GMT+10" },
  { name: "Etc/GMT+11", id: "Etc/GMT+11" },
  { name: "Etc/GMT+12", id: "Etc/GMT+12" },
  { name: "Etc/GMT+2", id: "Etc/GMT+2" },
  { name: "Etc/GMT+3", id: "Etc/GMT+3" },
  { name: "Etc/GMT+4", id: "Etc/GMT+4" },
  { name: "Etc/GMT+5", id: "Etc/GMT+5" },
  { name: "Etc/GMT+6", id: "Etc/GMT+6" },
  { name: "Etc/GMT+7", id: "Etc/GMT+7" },
  { name: "Etc/GMT+8", id: "Etc/GMT+8" },
  { name: "Etc/GMT+9", id: "Etc/GMT+9" },
  { name: "Etc/GMT-1", id: "Etc/GMT-1" },
  { name: "Etc/GMT-10", id: "Etc/GMT-10" },
  { name: "Etc/GMT-11", id: "Etc/GMT-11" },
  { name: "Etc/GMT-12", id: "Etc/GMT-12" },
  { name: "Etc/GMT-13", id: "Etc/GMT-13" },
  { name: "Etc/GMT-14", id: "Etc/GMT-14" },
  { name: "Etc/GMT-2", id: "Etc/GMT-2" },
  { name: "Etc/GMT-3", id: "Etc/GMT-3" },
  { name: "Etc/GMT-4", id: "Etc/GMT-4" },
  { name: "Etc/GMT-5", id: "Etc/GMT-5" },
  { name: "Etc/GMT-6", id: "Etc/GMT-6" },
  { name: "Etc/GMT-7", id: "Etc/GMT-7" },
  { name: "Etc/GMT-8", id: "Etc/GMT-8" },
  { name: "Etc/GMT-9", id: "Etc/GMT-9" },
  { name: "Etc/Greenwich", id: "Etc/Greenwich" },
  { name: "Etc/UCT", id: "Etc/UCT" },
  { name: "Etc/Universal", id: "Etc/Universal" },
  { name: "Etc/UTC", id: "Etc/UTC" },
  { name: "Etc/Zulu", id: "Etc/Zulu" },
  { name: "Europe/Amsterdam", id: "Europe/Amsterdam" },
  { name: "Europe/Andorra", id: "Europe/Andorra" },
  { name: "Europe/Athens", id: "Europe/Athens" },
  { name: "Europe/Belfast", id: "Europe/Belfast" },
  { name: "Europe/Belgrade", id: "Europe/Belgrade" },
  { name: "Europe/Berlin", id: "Europe/Berlin" },
  { name: "Europe/Bratislava", id: "Europe/Bratislava" },
  { name: "Europe/Brussels", id: "Europe/Brussels" },
  { name: "Europe/Bucharest", id: "Europe/Bucharest" },
  { name: "Europe/Budapest", id: "Europe/Budapest" },
  { name: "Europe/Busingen", id: "Europe/Busingen" },
  { name: "Europe/Chisinau", id: "Europe/Chisinau" },
  { name: "Europe/Copenhagen", id: "Europe/Copenhagen" },
  { name: "Europe/Dublin", id: "Europe/Dublin" },
  { name: "Europe/Gibraltar", id: "Europe/Gibraltar" },
  { name: "Europe/Guernsey", id: "Europe/Guernsey" },
  { name: "Europe/Helsinki", id: "Europe/Helsinki" },
  { name: "Europe/Isle_of_Man", id: "Europe/Isle_of_Man" },
  { name: "Europe/Istanbul", id: "Europe/Istanbul" },
  { name: "Europe/Jersey", id: "Europe/Jersey" },
  { name: "Europe/Kaliningrad", id: "Europe/Kaliningrad" },
  { name: "Europe/Kiev", id: "Europe/Kiev" },
  { name: "Europe/Lisbon", id: "Europe/Lisbon" },
  { name: "Europe/Ljubljana", id: "Europe/Ljubljana" },
  { name: "Europe/London", id: "Europe/London" },
  { name: "Europe/Luxembourg", id: "Europe/Luxembourg" },
  { name: "Europe/Madrid", id: "Europe/Madrid" },
  { name: "Europe/Malta", id: "Europe/Malta" },
  { name: "Europe/Mariehamn", id: "Europe/Mariehamn" },
  { name: "Europe/Minsk", id: "Europe/Minsk" },
  { name: "Europe/Monaco", id: "Europe/Monaco" },
  { name: "Europe/Moscow", id: "Europe/Moscow" },
  { name: "Europe/Nicosia", id: "Europe/Nicosia" },
  { name: "Europe/Oslo", id: "Europe/Oslo" },
  { name: "Europe/Paris", id: "Europe/Paris" },
  { name: "Europe/Podgorica", id: "Europe/Podgorica" },
  { name: "Europe/Prague", id: "Europe/Prague" },
  { name: "Europe/Riga", id: "Europe/Riga" },
  { name: "Europe/Rome", id: "Europe/Rome" },
  { name: "Europe/Samara", id: "Europe/Samara" },
  { name: "Europe/San_Marino", id: "Europe/San_Marino" },
  { name: "Europe/Sarajevo", id: "Europe/Sarajevo" },
  { name: "Europe/Simferopol", id: "Europe/Simferopol" },
  { name: "Europe/Skopje", id: "Europe/Skopje" },
  { name: "Europe/Sofia", id: "Europe/Sofia" },
  { name: "Europe/Stockholm", id: "Europe/Stockholm" },
  { name: "Europe/Tallinn", id: "Europe/Tallinn" },
  { name: "Europe/Tirane", id: "Europe/Tirane" },
  { name: "Europe/Tiraspol", id: "Europe/Tiraspol" },
  { name: "Europe/Uzhgorod", id: "Europe/Uzhgorod" },
  { name: "Europe/Vaduz", id: "Europe/Vaduz" },
  { name: "Europe/Vatican", id: "Europe/Vatican" },
  { name: "Europe/Vienna", id: "Europe/Vienna" },
  { name: "Europe/Vilnius", id: "Europe/Vilnius" },
  { name: "Europe/Volgograd", id: "Europe/Volgograd" },
  { name: "Europe/Warsaw", id: "Europe/Warsaw" },
  { name: "Europe/Zagreb", id: "Europe/Zagreb" },
  { name: "Europe/Zaporozhye", id: "Europe/Zaporozhye" },
  { name: "Europe/Zurich", id: "Europe/Zurich" },
  { name: "GB", id: "GB" },
  { name: "GB-Eire", id: "GB-Eire" },
  { name: "GMT", id: "GMT" },
  { name: "Greenwich", id: "Greenwich" },
  { name: "Hongkong", id: "Hongkong" },
  { name: "Iceland", id: "Iceland" },
  { name: "Indian/Antananarivo", id: "Indian/Antananarivo" },
  { name: "Indian/Chagos", id: "Indian/Chagos" },
  { name: "Indian/Christmas", id: "Indian/Christmas" },
  { name: "Indian/Cocos", id: "Indian/Cocos" },
  { name: "Indian/Comoro", id: "Indian/Comoro" },
  { name: "Indian/Kerguelen", id: "Indian/Kerguelen" },
  { name: "Indian/Mahe", id: "Indian/Mahe" },
  { name: "Indian/Maldives", id: "Indian/Maldives" },
  { name: "Indian/Mauritius", id: "Indian/Mauritius" },
  { name: "Indian/Mayotte", id: "Indian/Mayotte" },
  { name: "Indian/Reunion", id: "Indian/Reunion" },
  { name: "Iran", id: "Iran" },
  { name: "Israel", id: "Israel" },
  { name: "Jamaica", id: "Jamaica" },
  { name: "Japan", id: "Japan" },
  { name: "Kwajalein", id: "Kwajalein" },
  { name: "Libya", id: "Libya" },
  { name: "MET", id: "MET" },
  { name: "Mexico/BajaNorte", id: "Mexico/BajaNorte" },
  { name: "Mexico/BajaSur", id: "Mexico/BajaSur" },
  { name: "Mexico/General", id: "Mexico/General" },
  { name: "MST7MDT", id: "MST7MDT" },
  { name: "Navajo", id: "Navajo" },
  { name: "NZ", id: "NZ" },
  { name: "NZ-CHAT", id: "NZ-CHAT" },
  { name: "Pacific/Apia", id: "Pacific/Apia" },
  { name: "Pacific/Auckland", id: "Pacific/Auckland" },
  { name: "Pacific/Chatham", id: "Pacific/Chatham" },
  { name: "Pacific/Chuuk", id: "Pacific/Chuuk" },
  { name: "Pacific/Easter", id: "Pacific/Easter" },
  { name: "Pacific/Efate", id: "Pacific/Efate" },
  { name: "Pacific/Enderbury", id: "Pacific/Enderbury" },
  { name: "Pacific/Fakaofo", id: "Pacific/Fakaofo" },
  { name: "Pacific/Fiji", id: "Pacific/Fiji" },
  { name: "Pacific/Funafuti", id: "Pacific/Funafuti" },
  { name: "Pacific/Galapagos", id: "Pacific/Galapagos" },
  { name: "Pacific/Gambier", id: "Pacific/Gambier" },
  { name: "Pacific/Guadalcanal", id: "Pacific/Guadalcanal" },
  { name: "Pacific/Guam", id: "Pacific/Guam" },
  { name: "Pacific/Honolulu", id: "Pacific/Honolulu" },
  { name: "Pacific/Johnston", id: "Pacific/Johnston" },
  { name: "Pacific/Kiritimati", id: "Pacific/Kiritimati" },
  { name: "Pacific/Kosrae", id: "Pacific/Kosrae" },
  { name: "Pacific/Kwajalein", id: "Pacific/Kwajalein" },
  { name: "Pacific/Majuro", id: "Pacific/Majuro" },
  { name: "Pacific/Marquesas", id: "Pacific/Marquesas" },
  { name: "Pacific/Midway", id: "Pacific/Midway" },
  { name: "Pacific/Nauru", id: "Pacific/Nauru" },
  { name: "Pacific/Niue", id: "Pacific/Niue" },
  { name: "Pacific/Norfolk", id: "Pacific/Norfolk" },
  { name: "Pacific/Noumea", id: "Pacific/Noumea" },
  { name: "Pacific/Pago_Pago", id: "Pacific/Pago_Pago" },
  { name: "Pacific/Palau", id: "Pacific/Palau" },
  { name: "Pacific/Pitcairn", id: "Pacific/Pitcairn" },
  { name: "Pacific/Pohnpei", id: "Pacific/Pohnpei" },
  { name: "Pacific/Ponape", id: "Pacific/Ponape" },
  { name: "Pacific/Port_Moresby", id: "Pacific/Port_Moresby" },
  { name: "Pacific/Rarotonga", id: "Pacific/Rarotonga" },
  { name: "Pacific/Saipan", id: "Pacific/Saipan" },
  { name: "Pacific/Samoa", id: "Pacific/Samoa" },
  { name: "Pacific/Tahiti", id: "Pacific/Tahiti" },
  { name: "Pacific/Tarawa", id: "Pacific/Tarawa" },
  { name: "Pacific/Tongatapu", id: "Pacific/Tongatapu" },
  { name: "Pacific/Truk", id: "Pacific/Truk" },
  { name: "Pacific/Wake", id: "Pacific/Wake" },
  { name: "Pacific/Wallis", id: "Pacific/Wallis" },
  { name: "Pacific/Yap", id: "Pacific/Yap" },
  { name: "Poland", id: "Poland" },
  { name: "Portugal", id: "Portugal" },
  { name: "PRC", id: "PRC" },
  { name: "PST8PDT", id: "PST8PDT" },
  { name: "ROK", id: "ROK" },
  { name: "Singapore", id: "Singapore" },
  { name: "Turkey", id: "Turkey" },
  { name: "UCT", id: "UCT" },
  { name: "Universal", id: "Universal" },
  { name: "US/Alaska", id: "US/Alaska" },
  { name: "US/Aleutian", id: "US/Aleutian" },
  { name: "US/Arizona", id: "US/Arizona" },
  { name: "US/Central", id: "US/Central" },
  { name: "US/Eastern", id: "US/Eastern" },
  { name: "US/East-Indiana", id: "US/East-Indiana" },
  { name: "US/Hawaii", id: "US/Hawaii" },
  { name: "US/Indiana-Starke", id: "US/Indiana-Starke" },
  { name: "US/Michigan", id: "US/Michigan" },
  { name: "US/Mountain", id: "US/Mountain" },
  { name: "US/Pacific", id: "US/Pacific" },
  { name: "US/Samoa", id: "US/Samoa" },
  { name: "UTC", id: "UTC" },
  { name: "WET", id: "WET" },
  { name: "W-SU", id: "W-SU" },
  { name: "Zulu", id: "Zulu" },
];

export const BANNER_TYPES = [
  { name: "Banner - Image", value: "image" },
  { name: "Banner - Javascript", value: "js" },
  { name: "Video - VAST Tag", value: "vasttag" },
  { name: "Video - VAST Assets", value: "vast_asset" },
  { name: "Native Banner", value: "native" },
];

export const VIDEO_BANNER_SIZES = [
  { name: "Small", value: "300x250,320x250" },
  { name: "Medium", value: "320x480,480x320" },
  { name: "Large", value: "1024x768,768x1024" },
];
export const IMAGE_BANNER_SIZES = [
  { name: "320x50", value: "320x50,300x50" },
  { name: "300x100", value: "320x100,300x100" },
  { name: "300x250", value: "300x250,320x250" },
  { name: "320x480", value: "320x480,480x320" },
  { name: "728x90", value: "728x90,90x728" },
  { name: "1024x768", value: "1024x768,768x1024" },
  { name: "320x568", value: "320x568,568x320" },
  { name: "160x600", value: "160x600,600x160" },
  { name: "300x600", value: "300x600,600x300" },
  { name: "250x250", value: "250x250,250x250" },
  { name: "200x200", value: "200x200" },
  { name: "720x1280", value: "720x1280,1280x720" },
];
export const COUNTRY_DAIL_CODE_LIST = [
  { label: "Afghanistan", value: "+93" },
  { label: "Albania", value: "+355" },
  { label: "Algeria", value: "+213" },
  { label: "Andorra", value: "+376" },
  { label: "Angola", value: "+244" },
  { label: "Argentina", value: "+54" },
  { label: "Armenia", value: "+374" },
  { label: "Aruba", value: "+297" },
  { label: "Ascension", value: "+247" },
  { label: "Australia", value: "+61" },
  { label: "Austria", value: "+43" },
  { label: "Azerbaijan", value: "+994" },
  { label: "Bahrain", value: "+973" },
  { label: "Bangladesh", value: "+880" },
  { label: "Belarus", value: "+375" },
  { label: "Belgium", value: "+32" },
  { label: "Belize", value: "+501" },
  { label: "Benin", value: "+229" },
  { label: "Bhutan", value: "+975" },
  { label: "Bolivia", value: "+591" },
  { label: "Bosnia and Herzegovina", value: "+387" },
  { label: "Botswana", value: "+267" },
  { label: "Brazil", value: "+55" },
  { label: "Brunei", value: "+73" },
  { label: "Bulgaria", value: "+359" },
  { label: "Burkina Faso", value: "+226" },
  { label: "Burundi", value: "+257" },
  { label: "Cambodia", value: "+855" },
  { label: "Cameroon", value: "+237" },
  { label: "Cape Verde", value: "+238" },
  { label: "Central African Republic", value: "+236" },
  { label: "Chad", value: "+235" },
  { label: "Chile", value: "+56" },
  { label: "China", value: "+86" },
  { label: "Colombia", value: "+57" },
  { label: "Comoros", value: "+269" },
  { label: "Congo", value: "+242" },
  { label: "Cook Islands", value: "+682" },
  { label: "Costa Rica", value: "+506" },
  { label: "Croatia", value: "+385" },
  { label: "Cuba", value: "+53" },
  { label: "Cyprus", value: "+357" },
  { label: "Czech Republic", value: "+420" },
  { label: "Democratic Republic of Congo", value: "+243" },
  { label: "Denmark", value: "+45" },
  { label: "Diego Garcia", value: "+246" },
  { label: "Djibouti", value: "+253" },
  { label: "East Timor", value: "+670" },
  { label: "Ecuador", value: "+593" },
  { label: "Egypt", value: "+20" },
  { label: "El Salvador", value: "+503" },
  { label: "Equatorial Guinea", value: "+240" },
  { label: "Eritrea", value: "+291" },
  { label: "Estonia", value: "+372" },
  { label: "Ethiopia", value: "+251" },
  { label: "Falkland (Malvinas) Islands", value: "+500" },
  { label: "Faroe Islands", value: "+298" },
  { label: "Fiji", value: "+679" },
  { label: "Finland", value: "+358" },
  { label: "France", value: "+33" },
  { label: "French Guiana", value: "+594" },
  { label: "French Polynesia", value: "+689" },
  { label: "Gabon", value: "+241" },
  { label: "Gambia", value: "+220" },
  { label: "Georgia", value: "+995" },
  { label: "Germany", value: "+49" },
  { label: "Ghana", value: "+233" },
  { label: "Gibraltar", value: "+350" },
  { label: "Greece", value: "+30" },
  { label: "Greenland", value: "+299" },
  { label: "Guadeloupe", value: "+590" },
  { label: "Guatemala", value: "+502" },
  { label: "Guinea", value: "+224" },
  { label: "Guinea-Bissau", value: "+245" },
  { label: "Guyana", value: "+592" },
  { label: "Haiti", value: "+509" },
  { label: "Honduras", value: "+504" },
  { label: "Hong Kong", value: "+852" },
  { label: "Hungary", value: "+36" },
  { label: "Iceland", value: "+354" },
  { label: "India", value: "+91" },
  { label: "Indonesia", value: "+62" },
  { label: "Inmarsat Satellite", value: "+870" },
  { label: "Iran", value: "+98" },
  { label: "Iraq", value: "+964" },
  { label: "Ireland", value: "+353" },
  { label: "Israel", value: "+972" },
  { label: "Italy", value: "+39" },
  { label: "Ivory Coast", value: "+225" },
  { label: "Japan", value: "+81" },
  { label: "Jordan", value: "+962" },
  { label: "Russian Federation", value: "+7" },
  { label: "Kenya", value: "+254" },
  { label: "Kiribati", value: "+686" },
  { label: "Kuwait", value: "+965" },
  { label: "Kyrgyzstan", value: "+996" },
  { label: "Laos", value: "+856" },
  { label: "Latvia", value: "+371" },
  { label: "Lebanon", value: "+961" },
  { label: "Lesotho", value: "+266" },
  { label: "Liberia", value: "+231" },
  { label: "Libya", value: "+218" },
  { label: "Liechtenstein", value: "+423" },
  { label: "Lithuania", value: "+370" },
  { label: "Luxembourg", value: "+352" },
  { label: "Macau", value: "+853" },
  { label: "Macedonia", value: "+389" },
  { label: "Madagascar", value: "+261" },
  { label: "Malawi", value: "+265" },
  { label: "Malaysia", value: "+60" },
  { label: "Maldives", value: "+960" },
  { label: "Mali", value: "+223" },
  { label: "Malta", value: "+356" },
  { label: "Marshall Islands", value: "+692" },
  { label: "Martinique", value: "+596" },
  { label: "Mauritania", value: "+222" },
  { label: "Mauritius", value: "+230" },
  { label: "Reunion", value: "+262" },
  { label: "Mexico", value: "+52" },
  { label: "Micronesia", value: "+691" },
  { label: "Moldova", value: "+373" },
  { label: "Monaco", value: "+377" },
  { label: "Mongolia", value: "+976" },
  { label: "Montenegro", value: "+382" },
  { label: "Morocco", value: "+212" },
  { label: "Mozambique", value: "+258" },
  { label: "Myanmar", value: "+95" },
  { label: "Namibia", value: "+264" },
  { label: "Nauru", value: "+674" },
  { label: "Nepal", value: "+977" },
  { label: "Netherlands", value: "+31" },
  { label: "Netherlands Antilles", value: "+599" },
  { label: "New Caledonia", value: "+687" },
  { label: "New Zealand", value: "+64" },
  { label: "Nicaragua", value: "+505" },
  { label: "Niger", value: "+227" },
  { label: "Nigeria", value: "+234" },
  { label: "Niue Island", value: "+683" },
  { label: "North Korea", value: "+850" },
  { label: "Norway", value: "+47" },
  { label: "Oman", value: "+968" },
  { label: "Pakistan", value: "+92" },
  { label: "Palau", value: "+680" },
  { label: "Panama", value: "+507" },
  { label: "Papua New Guinea", value: "+675" },
  { label: "Paraguay", value: "+595" },
  { label: "Peru", value: "+51" },
  { label: "Philippines", value: "+63" },
  { label: "Poland", value: "+48" },
  { label: "Portugal", value: "+351" },
  { label: "Qatar", value: "+974" },
  { label: "Romania", value: "+40" },
  { label: "Rwanda", value: "+250" },
  { label: "Saint Helena", value: "+290" },
  { label: "Saint Pierre and Miquelon", value: "+508" },
  { label: "Samoa", value: "+685" },
  { label: "San Marino", value: "+378" },
  { label: "Sao Tome and Principe", value: "+239" },
  { label: "Saudi Arabia", value: "+966" },
  { label: "Senegal", value: "+221" },
  { label: "Serbia", value: "+381" },
  { label: "Seychelles", value: "+248" },
  { label: "Sierra Leone", value: "+232" },
  { label: "Singapore", value: "+65" },
  { label: "Slovakia", value: "+421" },
  { label: "Slovenia", value: "+386" },
  { label: "Solomon Islands", value: "+677" },
  { label: "Somalia", value: "+252" },
  { label: "South Africa", value: "+27" },
  { label: "South Korea", value: "+82" },
  { label: "Spain", value: "+34" },
  { label: "Sri Lanka", value: "+94" },
  { label: "Sudan", value: "+249" },
  { label: "Suriname", value: "+597" },
  { label: "Swaziland", value: "+268" },
  { label: "Sweden", value: "+46" },
  { label: "Switzerland", value: "+41" },
  { label: "Syria", value: "+963" },
  { label: "Taiwan", value: "+886" },
  { label: "Tajikistan", value: "+992" },
  { label: "Tanzania", value: "+255" },
  { label: "Thailand", value: "+66" },
  { label: "Togo", value: "+228" },
  { label: "Tokelau", value: "+690" },
  { label: "Tunisia", value: "+216" },
  { label: "Turkey", value: "+90" },
  { label: "Turkmenistan", value: "+993" },
  { label: "Tuvalu", value: "+688" },
  { label: "Uganda", value: "+256" },
  { label: "Ukraine", value: "+380" },
  { label: "United Arab Emirates", value: "+971" },
  { label: "United Kingdom", value: "+44" },
  { label: "United States of America", value: "+1" },
  { label: "Uruguay", value: "+598" },
  { label: "Uzbekistan", value: "+998" },
  { label: "Vanuatu", value: "+678" },
  { label: "Vatican City", value: "+379" },
  { label: "Venezuela", value: "+58" },
  { label: "Vietnam", value: "+84" },
  { label: "Wallis and Futuna", value: "+681" },
  { label: "Yemen", value: "+967" },
  { label: "Zambia", value: "+260" },
  { label: "Zimbabwe", value: "+263" },
];
